/* eslint-disable */

/*
  Pablo 15-jun-2026: Service Worker DESREGISTRADO.
  El admin antes registraba un SW (Workbox via @vue/cli-plugin-pwa) que
  cacheaba el bundle JS agresivamente. Eso impedia que los deploys de
  fix aparecieran sin un hard refresh manual del navegador.
  Como admin.surreal.travel no necesita modo offline ni PWA install,
  desregistramos cualquier SW activo en cuanto carga la app y nunca
  registramos uno nuevo. Asi cada deploy se ve al instante en el
  proximo reload normal.
*/

if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const reg of registrations) {
      reg.unregister().then(() => {
        console.log('[admin] SW desregistrado:', reg.scope);
      });
    }
  });

  if ('caches' in window) {
    caches.keys().then((keys) => {
      keys.forEach((k) => caches.delete(k));
    });
  }
}
